import { createContext, useContext } from "react";
import type { InterpolatedPeriod } from "web_myplann/Portfolio/Helpers/interpolatedPeriods";

const InterpolatedPeriodsContext = createContext<InterpolatedPeriod[]>([]);

export const InterpolatedPeriodsProvider = InterpolatedPeriodsContext.Provider;

export const useInterpolatedPeriods = () =>
	useContext(InterpolatedPeriodsContext);
